import styled from 'styled-components';
import { getStatusColor } from '../../utils/colors';

export const CircleStatus = styled.span`
  background-color: ${p => getStatusColor(p.status, p.theme, p.type)};
  height: 10px;
  width: 10px;
  min-width: 10px;
  margin-right: 10px;
  border-radius: 10px;
`;

export const StyledStatusLabel = styled.label`
  display: inline-flex;
  align-items: center;
  margin: 0;
  font-family: ${props => props.theme.fonts.gtEesti};
  color: ${props => props.theme.colors.black};
  white-space: nowrap;
  font-size: 12px;
  letter-spacing: 0.4px;
  line-height: 14px;
  text-transform: uppercase;
`;
